import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
// import { Analytics } from '@vercel/analytics/react';
// import { Features } from "./components/features";
import { Analytics } from '@vercel/analytics/react';
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Sponsors } from "./components/sponsors";
import { Contact } from "./components/contact";
import { NotFound } from "./404/404";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { inject } from '@vercel/analytics';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Reveal from "./helpers/AnimationRevealPage";
import ProductPage from "src/pages/Product";
import MaintenancePage from "src/pages/Maintenance";
import PrivacyPolicy from "src/pages/Policy";
import TermsAndRefundPolicy from "src/pages/Terms";
import Documentation from "src/pages/Documentation";
import WaitlistPage from "src/pages/Waitlist";
import MerryChristmasPage from "./pages/merry/christmas";
import HappyNewYearPage from "./pages/newyear/newyear";
// import ChristmasRoute from "./pages/christmasroute";
 
inject();

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});



const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);


  // const homepage = () => {
  //   return (
  //     <>
  //     <div>
  //       <Navigation />
  //       <Header data={landingPageData.Header} />
  //       {/* <Features data={landingPageData.Features} /> */}
  //       <About data={landingPageData.About} />
  //       <Services data={landingPageData.Services} />
  //       <Gallery data={landingPageData.Gallery} />
  //       <Testimonials data={landingPageData.Testimonials} />
  //       <Team data={landingPageData.Team} />
  //       <Sponsors data={landingPageData.Sponsors} />
  //       <Contact data={landingPageData.Contact} />
  //     </div>
  //     <Analytics/>
  //       <SpeedInsights/>
  //     </>
  //   );
  // }

  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element = {<><div>
            <Navigation />
            <Header data={landingPageData.Header} />
            {/* <Features data={landingPageData.Features} /> */}
            <About data={landingPageData.About} />
            <Services data={landingPageData.Services} />
            <Gallery data={landingPageData.Gallery} />
            <Testimonials data={landingPageData.Testimonials} />
            <Team data={landingPageData.Team} />
            <Sponsors data={landingPageData.Sponsors} />
            <Contact data={landingPageData.Contact} />
          </div>
          <Analytics/>
            <SpeedInsights/>
            </>} 
        />
        <Route path="/product/:id" element ={<ProductPage/>}/>
        <Route path="/product/:id/docs" element = {<Documentation/>}/>
        <Route path="/:id/docs" element = {<Documentation/>}/>
        <Route path="/notfound" element ={<NotFound/>} />
        <Route path="/docs" element ={<MaintenancePage/>}/>
        <Route path="/privacy-policy" element ={<PrivacyPolicy/>}/>
        <Route path="/terms" element = {<TermsAndRefundPolicy/>}/>
        <Route path="/product/:id/waitlist" element ={<WaitlistPage/>}/>
        <Route path="/christmas" element = {<MerryChristmasPage/>}/>
        <Route path="/new-year" element = {<HappyNewYearPage/>}/>
      </Routes>
    </Router>
    {/* <div> */}
      {/* <Navigation /> */}
      {/* <Header data={landingPageData.Header} /> */}
      {/* <Features data={landingPageData.Features} /> */}
      {/* <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />
      <Team data={landingPageData.Team} />
      <Sponsors data={landingPageData.Sponsors} />
      <Contact data={landingPageData.Contact} /> */}
    {/* </div> */}
    {/* <Analytics/>
      <SpeedInsights/> */}
    </>
  );
};

export default App;
